if (!customElements.get('comparison-tool')) {
  customElements.define('comparison-tool', class ComparisonTool extends HTMLElement {
    constructor() {
      super();

      this.productColumns = this.querySelectorAll('.comparison-tool__product');
      this.navigationButtons = this.querySelector('.comparison-slider-buttons');

      this.header = document.querySelector('.section-header');
      this.headerHiddenClass = 'comparison-header-hidden';
    }

    connectedCallback() {
      this.evenOutHeights();
      window.addEventListener('resize', () => {
        this.evenOutHeights();
      });


      // if section is scrolled to hide header and if scrolled past show header, use observer on desktop
      if (window.innerWidth > 750) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.header.classList.add(this.headerHiddenClass);
            } else {
              this.header.classList.remove(this.headerHiddenClass);
            }
          });
        })

        observer.observe(this);
      }
    }

    evenOutHeights() {
      requestAnimationFrame(() => {
        let heights = [];

        this.productColumns.forEach((product) => {
          const rows = product.querySelectorAll('.comparison-tool__products--detail:not(.key-features), product-card, product-card .card__content');
          rows.forEach((row, index) => {
            row.style.minHeight = 'unset';
            const rowHeight = row.offsetHeight;

            if (heights[index] === undefined || rowHeight > heights[index]) {
              heights[index] = rowHeight;
            }
          });
        });

        this.productColumns.forEach((product) => {
          const rows = product.querySelectorAll('.comparison-tool__products--detail:not(.key-features), product-card, product-card .card__content');
          rows.forEach((row, index) => {
            row.style.minHeight = `${heights[index]}px`;
          });
        });
      });

      this.prevWindowWidth = window.innerWidth;
    }
  });
};

class CollapsibleFeatures extends HTMLElement {
  constructor() {
    super();

    this.accordionButton = this.querySelector(".accordion-trigger");
    this.accordionButtonContent = this.querySelector(".accordion-trigger > span:not(.animated-icon-plus)");
    this.accordionContent = this.querySelector(".accordion-content");
    this.accordionShowMore = this.dataset.accordionShowMore;
    this.accordionShowLess = this.dataset.accordionShowLess;
  }

  connectedCallback() {

    if (this.accordionButton === null) return;
    this.accordionButton.addEventListener("click", (e) => {
      this.handleAccordionClick.bind(this)(e);
    });
  }

  handleAccordionClick() {

    const ariaExpanded = this.accordionButton.getAttribute("aria-expanded");
    if (ariaExpanded === "false") {
        this.accordionButton.setAttribute("aria-expanded", "true");
        this.accordionContent.setAttribute("aria-hidden", "false");
        this.accordionButtonContent.innerHTML = this.accordionShowLess;
    } else {
        this.accordionButton.setAttribute("aria-expanded", "false");
        this.accordionContent.setAttribute("aria-hidden", "true");
        this.accordionButtonContent.innerHTML = this.accordionShowMore;
    }
  }
}

customElements.define("collapsible-features", CollapsibleFeatures);